import styled from "styled-components";

import Epost from ".././components/Epost";

import Blandat from "./../images/artister/2024/blandat.jpg";

import Algotsson from "./../images/artister/2025/mathias_algotsson.jpg";

import Strato from "./../images/artister/2025/lasse-strato.jpg";

import Brasa from "./../images/artister/2025/brasa.jpg";

const ExtraImage = styled.img`
  width: 180px;
  float: left;
  margin: 2px 1rem 0.3rem 0;
`;


const artistInfo = [
  /*
  {
    id: 1,
    namn: function () {
      return <>SÄSONGSÖPPNING</>;
    },
    info: function () {
      return (
        <>
          <p>
            Påskafton kl. 11 öppnar krogen dörrarna för säsongen!<br />
            Sedan kommer vi ha öppet lördagar, söndagar och helgdagar kl. 11 - 15.
            <br />Fr.o.m. skolavslutningen 12 juni har vi öppet dagligen; vardagar 11 - 17 och helger 11 - 16.
          </p>
          <p>
            Varmt välkomna till påsk!
          </p>
        </>
      );
    },
    datum: "2025-04-19",
    img: "säsongsöppning",
    pris: 1,
    tid: "11:00",
    konsertmeny: false,
    music: false,
    konst: false,
    author: false,
  },


  {
    id: 2,
    namn: function () {
      return <>MIDSOMMARAFTON</>;
    },
    info: function () {
      return (
        <>
          <p>
            Traditionsenligt så firar vi midsommar på Oxelö Krog med dans och lekar kring midsommarstången till levande musik!<br />

            Midsommarstången kommer att kläs och resas mellan kl 10 - 12.<br />
            Kl. 13 blir det musik och ringlekar!<br />

            <p>Caféet är öppet 10 till 16.
            </p>
            
            Denna dag har vi en speciell midsommarmeny.
            <ul>
              <li>Midsommartallrik 210 kr - 3 sorters sill, varmrökt lax, räkröra, gräddfil, gräslök, kokt ägg, potatis, smör och bröd.</li>
              <li> Varmrökt lax med färsk potatis och romröra samt smör och bröd</li>
              <li>Räksmörgås</li>
              <li> Pannkakor med grädde och sylt</li>
            </ul>

            <p>Dessutom har vi förstås fika med bland annat vår fina midsommartårta med jordgubbar</p>

          
            Varmt välkomna! < br /> <br />
            Glöm inte att ta med folkdräkt om du har en!
          </p >
  <p>OBS! På midsommarafton kommer det inte vara möjligt att parkera på Kroggränd eftersom vi kommer ha dansen där. Vi hänvisar istället till stora parkeringen.</p>
        </>
      );
    },
datum: "2025-06-20",
  img: "midsommar",
    pris: 0,
      tid: "",
        konsertmeny: false,
          music: true,
  },

{
  id: 3,
    namn: function () {
      return <>Margareta Bengtson</>;
    },
  info: function () {
    return (
      <>
        <p>
          Margareta Bengtson är en av Sveriges mest lysande jazzsångerskor. Hon är en av grundarna av den internationella succén The Real Group och har rest världen över och sjungit med sin fantastiska sopranröst. Klockrent, ekvilibristiskt och musikaliskt! Gruppen lämnade hon 2007 för en solokarriär som fick en flygande start med det kritikerrosade albumet I’m Oldfashioned.
          Under ett framträdande med anledning av Alice Babs 100-årsjubileum, i samband med Kungliga Musikaliska Akademiens årliga högtidssammankomst i måndags tilldelades Alice Babs jazzstipendium.
          Juryns motivering löd: ”Margareta Bengtson har under många år varit den vokalist som mest framgångsrikt och omsorgsfullt skapat musik i Alice Babs anda. Klangen, omfånget, den enastående smidigheten, den stora genrebredden och den höga konstnärliga nivån bidrar alla till att skapa en vokal karaktär som saknar motstycke i det svenska musiklivet.”
          Vi är otroligt glada över att kunna presentera Margareta Bengtson på krogbacken tillsammans med pianisten Mathias Algotsson!
        </p><p>
          <ExtraImage src={Algotsson} />
          Margareta Bengtson & Mathias Algotsson har ett långt samarbete i bagaget. De vill möta publiken i en gränsöverskridande konsert där den traditionella jazzen ligger som grund, men som också innehåller improvisationer över folkliga koraler, visor och egna kompositioner. Hösten 2016 släppte Margareta och Mathias ett album i Japan, ”Ballads”, tillsammans med några av Sveriges mest renommerade jazzmusiker, som fått mycket fina recensioner. Skivan följdes upp av en lång och mycket lyckad turné i Japan november och december samma år. Ytterligare en cd spelades in som släpptes i Sverige under 2017, ”Sorgen och Glädjen”, där Margareta och Mathias improviserar över svenska psalmer, koraler och visor.
        </p><p>
          Margareta Bengtson har en lång karriär som internationellt erkänd sångerska, harpist, kompositör och arrangör. Med stor nyfikenhet fortsätter hon att utforska olika musikaliska världar och rum, med en önskan om att hennes uttryck ska få beröra, trösta, glädja och även visa ett andligt perspektiv på tillvaron. Möten med andra musiker som inspirerar är också en stark drivkraft i hennes konstnärsskap. Margareta växte upp i en musikerfamilj i Tyresö utanför Stockholm. Hon började tidigt sjunga och spela piano och så småningom harpa, som blev hennes huvudinstrument vid Kungliga Musikhögskolan i Stockholm. Den breda publiken kanske mest känner till henne som en av grundarna till a capella ensemblen The Real Group, som rönt stora framgångar över hela världen i flera decennier, och som erhållit många priser och utmärkelser. Bland annat blev Margareta utnämnd till Best Female Vocalist av den amerikanska organisationen CASA 1997. Hon samarbetar numera med Sveriges jazzelit och finaste improvisationsmusiker, såväl som med klassiska kammarmusiker, körer och orkestrar på högsta nivå, och skriver även egen musik. Hösten 2024 fick Margareta ta emot Alice Babs jazz-stipendium som delades ut av Kungl. Musikaliska Akademien.
        </p><p>
          Mathias Algotsson har varit aktiv sedan mitten av nittiotalet och har sedan dess spelat runt om i världen med välkända namn som t.ex. Barbara Hendricks, Magnus Lindgren, Rigmor Gustafsson, Margareta Bengtson (the Real Group) och Svante Henryson. Mathias har en förmåga att förflytta sig mellan olika genrer och stilar och är också en uppskattad kompositör. Han har, förutom till egna grupper, skrivit musik bland annat till Sofia Vokalensemble, Gustaf Sjökvists Kammarkör och S:t Görans Kammarkör. Mathias har gjort sex album i helt eget namn, senast ”Home at Work Again” med egen kvartett. Han har tilldelats ”Dompans Guldsax” som den ende icke-saxofonist som fått Arne Domnerus jazzpris, och också erhållit Sollentuna kommuns kulturpris 2019, stipendier från STIM, SKAP
        </p>
      </>
    );
  },
  datum: "2025-06-28",
    img: "Margareta-Bengtsson",
      foto: "Ewa-Marie Rundquist",
        pris: 230,
          tid: "18:00",
            konsertmeny: true,
              music: true,
                youtube: "https://www.youtube.com/watch?v=XAdF2ys6wkM",
                  youtubenamn: "Margareta Bengtson & Mathias Algotsson - teaser",
                    youtube2: "https://www.youtube.com/watch?v=pxzmHL_GBqk",
                      youtubenamn2: "I'm old fashioned",
                        biljett_id: 1208203,
  },

{
  id: 4,
    namn: function () {
      return <>Peter Asplund och Emmalisa Hallander</>;
    },
  info: function () {
    return (
      <>
        <p>
          Världstrumpetaren Peter Asplund tillsammans det nya unga stjärnskottet; sångerskan Emmalisa Hallander!
        </p><p>
          Efter en över tre decennier lång karriär, med tio album i eget namn, priser och turnéer världen över, har trumpetaren, sångaren och kompositören Peter Asplund, med sitt karaktäristiskt vemodiga och dynamiska trumpetspel, i kombination med sina romantiska kompositioner och sin klassiska swingsångarröst, sin givna plats på jazzens världskarta.
        </p><p>
          Emmalisa Hallander är Sveriges senaste stjärnskott på jazzhimlen. Under senaste året har 24-åriga vokalisten spelat på ett fullsatt Fasching i eget namn, turnerat med Peter Asplund, sjungit som solist med Stockholm Jazz Orchestra, mottagit stipendier från Faschings Vänner, KMA och Sverker och Birgittas Stipendiefond och gjort sig ett namn bland Stockholms jazzelit. Hon har erhållit Alice Babs Talangstipendium och förra året även Monica Zetterlund stipendiet. Hon spelar för närvarande revy på Scalateatern i Stockholm och har ett rykande färskt album i bagaget.
        </p><p>
          Tillsammans med pianisten Leo Lindberg, basisten Christian
          Spering och trumslagaren Johan Löfcrantz Ramsay, tar
          musiken avstamp i The Great American Songbook, men
          blandas med egna kompositioner av Hallander och Asplund.
          Ambitionen är att presentera jazzmusik i formatet
          föreställning, snarare än konsert, där musiken varvas med
          historier, berättelser och anekdoter.

        </p>
      </>
    );
  },
  datum: "2025-07-05",
    img: "Peter-Asplund",
      foto: "",
        pris: 230,
          tid: "18:00",
            konsertmeny: true,
              music: true,
                youtube: "https://www.youtube.com/watch?v=G3-oACKi0Ds",
                  youtubenamn: "What we knew",
                    youtube2: "https://www.youtube.com/watch?v=CTZvtQHSj9I",
                      youtubenamn2: "Miljarder stjärnor",
                        biljett_id: 1258155,

  },

{
  id: 5,
    namn: function () {
      return <>Swing Magnifique</>;
    },
  info: function () {
    return (
      <>
        <p>
          SWING MAGNIFIQUE har länge varit ett av de flitigast anlitade och mest uppskattade banden inom Jazz Manouche/Gypsy Swing, den europeiska jazzstil som främst förknippas med den legendariska belgisk-franska gitarristen Django Reinhardt (1910-1953) och hans grupp Quintette du Hot Club de France, som han bildade i Paris 1934 tillsammans med violinisten Stéphane Grappelli.
          Jazz Manouche är vanligtvis instrumental men det har Swing Magnifique ändrat på: Med en sångerska i bandet består repertoaren delvis av vokala versioner av standards och franska schlagers som till viss del är hämtad från Djangos klassiska inspelningar, men låtar skrivna av Djangos nutida efterföljare samt en och annan egen komposition har också sin givna plats.
        </p><p>
          Allt framförs naturligtvis i Django Reinhardts omisskännliga stil där intensivt sväng och lekfulla, eldiga solon samsas med romantiskt vemod och där den viktigaste ingrediensen är energi. Vår idé är att undvika alltför långa solon utan istället fokusera på bra låtar. Det här är musik som det är svårt att inte beröras av! Våra jazzklubbsframträdanden är alltid mycket uppskattade av både publik och arrangörer.
          För att få det rätta, autentiska soundet har Swing Magnifique den klassiska sättningen för Jazz Manouche, dvs. två akustiska gitarrer, violin och kontrabas.
        </p><p>
          Kvintetten Swing Magnifique består av Josefin Peters (sång), Tom Buhre (gitarr), Filip Magnusson (violin), Åke Jonsson (gitarr), och Filip Berglund (kontrabas).
          Swing Magnifique bildades 2007 och är ett mycket erfaret band inom genren.
        </p><p>
          Välkomna till en afton med swing och elegans!
        </p>
      </>
    );
  },
  datum: "2025-07-12",
    img: "magnifique",
      foto: "",
        pris: 180,
          tid: "18:00",
            konsertmeny: true,
              music: true,
                youtube: "https://www.youtube.com/watch?v=o4o2F0vy7U8",
                  youtubenamn: "Cocou",
                    youtube2: "https://www.youtube.com/watch?v=MiVmEZtm8yw",
                      youtubenamn2: "Sometimes I'm happy",
                        biljett_id: 1258162,
  },

{
  id: 6,
    namn: function () {
      return <>Jojje Wadenius 4-Fusion</>;
    },
  info: function () {
    return (
      <>
        <p>
          Vi är glada och uppspelta över att kunna presentera en konsertkväll 4-Fusion med Georg “Jojje” Wadenius och trion Max Schultz, Leo Lindberg och Chris Montgomery! Kvällen bjuder på ett musikaliskt möte mellan funk och melodisk fusion med några stänk av jazz och blues.
        </p><p>
          Georg ”Jojje” Wadenius – en levande legend inom både svenskt och amerikanskt musikliv. Ingen annan svensk musiker förenar musikalisk briljans och kommersiell framgång som Jojje. Wadenius var under 80-talet en av de mest anlitade gitarristerna i New York och medverkande på skivinspelningar med bland annat Diana Ross, Aretha Franklin, Luther Vandross och Steely Dan. Han har även medverkat på turnéer med artister som James Brown, Kent och Simon & Garfunkel och spelat i husbandet till det amerikanska TV-programmet Saturday Night Live. I mitten av 90-talet återvände Wadenius till Skandinavien och sen dess har han spelat i egna band och spelat in egna skivor, producerat album åt andra artister, arbetat som solist med olika storband och undervisat. Han har även samarbetat med en rad stora artister i Sverige Pugh Rogefeldt, Siw Malmqvist och Cornelis Vreeswijk.
        </p><p>
          Den legendariska jazzgitarristen Max Schultz spelar och komponerar musik inom såväl jazz-, blues- och popgenren. Han började spela gitarr vid 10 års ålder efter att ha sett en konsert med Jimi Hendrix i Stockholm. Han har turnerat med bandet Rena vätskor och engagerat sig i gruppen Mynta, där han under sju år utvecklades som jazzgitarrist och även kom i kontakt med indiska musikaliska influenser. Mynta turnerade såväl i Skandinavien som på internationella arenor som Montreux Jazz Festival samt i Singapore, Bombay, Kuba och Nicaragua. 1993 vann Schultz Rikskonserters och Caprices utmärkelse Jazz i Sverige. Han har samarbetat med många jazzmusiker och artister, som Håkan Broström, Herbie Hancock, Bob Moses, Nils Landgren, Esbjörn Svensson, Svante Thuresson, Anna Nederdal och Tommy Körberg. Schultz har även arbetat som studiomusiker på inspelningar med Marie Fredriksson, Rebecka Törnqvist och andra artister.
        </p><p>
          Den hyllade pianisten Leo Lindberg har tilldelats flera priser, däribland Louis Armstrong-, Monica Zetterlunds- och Faschings Vänners stipendium, samt solistpriset i tävlingen Nordic Jazz Comets. Med influenser hämtade från bland annat Bud Powell och Wynton Kelly äger Lindberg en lysande konstnärlig fantasi som får musiken att slå ut i full blom, samt besitter en imponerande teknik med tonkaskader som är en fröjd att lyssna till. Sedan debutalbumet Leos Bag (2014) har flera andra skivor utkommit, såväl egna som i samverkan med andra profilerade musiker som sångerskan Rigmor Gustafsson och gitarristen Max Schultz.
        </p><p>
          Chris Montgomerys rykte som en dynamisk, flyhänt och samtidigt sofistikerad och sammanhållande trummis föregår honom och dessa egenskaper gör honom till ett givet val för många jazz och bluesmusiker och artister att samverka med i olika konstellationer. Chris har anlitats av och spelat med många etablerade profiler inom svensk jazz och blues/rock, bland annat Rigmor Gustafsson, Svante Thuresson, Max Schultz, Barbara Hendricks, Patrik Boman, Erik Söderlind, Leo Lindberg, Isabella Lundgren och Hans Backenroth.

        </p><p>
          Lineup:<br />
          Georg ”Jojje” Wadenius - gitarr, sång<br />
          Max Schultz - gitarr<br />
          Leo Lindberg - keyboards<br />
          Chris Montgomery - trummor
        </p>
        <p>
          Till konserten erbjuder vi en härlig <a rel="noreferrer" href={/konsertmat/} target="_blank">GRILLMENY</a> för 290 kr.
          Vår kock grillar 2 sorters kött och grönsaker över kolbädd, som serveras till er direkt från grillen. Som tillbehör har vi matiga sallader, goda såser & röror och bröd. Grillmenyn behöver förbeställas minst tre dagar före konserten.
        </p>
      </>
    );
  },
  datum: "2025-07-19",
    img: "Jojje",
      foto: "",
        pris: 280,
          tid: "18:00",
            konsertmeny: true,
              music: true,
                slutsålt: true,
                  youtube: "https://www.youtube.com/watch?v=AIQlxsEB4AE",
                    youtubenamn: "Live 2023",
                      biljett_id: 1258158,
  },

{
  id: 7,
    namn: function () {
      return <>The Blue Benders</>;
    },
  info: function () {
    return (
      <>
        <p>
          Denna konsert ingår i våra BLUESDAGAR 30 juli - 2 augusti. Under bluesdagarna kommer vi även ha blues dagtid med fri entré för de som gästar caféet. Biljett kan köpas separat till denna konsert men man kan även köpa ett BLUESPASS som ger entré till alla fyra blueskonserter till rabatterat pris.
        </p>
        <p>
          På drygt två år har The Blue Benders etablerat sig som en kraft att räkna med inom svensk blues/roots/soul/funk/rock. Inte bara som det nya unga blueshoppet, utan som en fulländad musikmaskin med ett sound och sväng som imponerar på det mest erfarna rock- och bluesrävarna. Ett band som dock inte vill låta dig definieras som enbart blues utan hämtar sina influenser från alla håll för att bilda en musikalisk cocktail från alla världar, där tunga riff möts av funkiga basgångar och hela tiden inspirerat av den afroamerikanska musiken
        </p>
        <p>
          Fronttrion, tillsammans med det tunga, ångvältande kompet är häpnadsväckande, eller ”onödigt bra”, som Roffe Wikström uttryckte det efter att de delat kväll med honom i Göteborg i december-21.
        </p>
        <p>
          Bandet, som tilldelades utmärkelsen "Årets Nykomling" i Bluespoddens omröstning 2022, har inte bara imponerat som kollektiv, utan även individuellt. Edvin Öström har två år i rad utsetts till "Årets Gitarrist", och sångaren och entertainergeniet Samson Mirro för den legendariska familjetraditionen vidare från farfar Eric Bibb och pappa Rennie Mirro. Morris Malek sanslösa slidegitarr spottar, frustar och fräser. Johan Sund (Lisa Lystam Family Band, the Bland, m fl), basisten och världsvirtuosen, är sedan hösten -22 ny basist i bandet. Trummisen och multigeniet Oskar Boså langar dynamik, sväng och stadga med sällsynt pondus, bidrar till bandets karakteristiska sound.
        </p>
        <p>
          I mitten av juli 2023 gick bandet in i Immersive music studios (gamla EMI studion) för att spela in nytt material. Resultatet blev EP:n "Strike One", som släpptes den 16e november 2023. Den efterlängtade EP:n bjuder på en ny dimension av bandets musikaliska talang och har fått enorm positiv respons från deras dedikerade fanbase. Med en utsåld releasekonsert på Nalen Klubb, 300 pers, i bagaget är bandet minst sagt inne i en spännande period och ser de fram emot att fortsätta sin resa under 2024.
        </p>
        <p>
          De gör det så bra att de tog hem vinsten i den svenska tävlingen av European Blues Challenge och drar till Portugal i april 2024 för att representera Sverige i bluesen egen Eurovision.
        </p>
        <p>
          Blue Benders live är en hyllad upplevelse och ett unikt samspel med publiken. Det är kvällar som aldrig vill ta slut.  Energi och spelglädje eller som trumlegendaren Ingemar Dunker (RIP) uttryckte det efter att han upplevt bandet live på Bangens Jazzfestival 2023, ”Det bästa jag hört på mycket mycket länge”
        </p>
        <p>
          Bandet har sitt ursprung ur Stockholms jam-scen i Gamla Stan. Edvin drog med sig Morris till jammen redan under första året på musikgymnasiet, Rytmus. Stampen, St Clara Wirströms, Engelen, etc blev deras musikaliska vattenhål under gymnasieåren. Samson kom snart in i bilden och det jammades i parti och minut. Tommy Moberg, den gamle legendaren, såg potentialen och satte ihop ett band omkring grabbarna, som hade sin första officiella spelning under namnet The Blue Benders i maj 2021 i samband med Old Town Blues Stream.
        </p>
      </>
    );
  },
  datum: "2025-07-30",
    img: "benders",
      pris: 200,
        tid: "18:00",
          konsertmeny: true,
            music: true,
              youtube: "https://www.youtube.com/watch?v=fDjFuCssGuE",
                foto: "",
                  slutsålt: false,
                    biljett_id: 1258156,
                      bluespass: 1264409,
  },

{
  id: 8,
    namn: function () {
      return <>Pete Simpson Blues</>;
    },
  info: function () {
    return (
      <>
        <p>
          Under våra BLUESDAGAR kommer bluessångaren och gitarristen Pete Simpson underhålla med sin trio på eftermiddagarna. Onsdag, torsdag, fredag och lördag kommer Pete och hans män lira två set på scenen, kl 13 och 15.
        </p>
        <p>
          PETESIMPSONBLUES spelar rytmisk ”BLUES and BEYOND”.<br />
          Gammalt och nytt med egna tolkningar samt egenskrivna låtar.
        </p>
        <p>
          Sättning:<br />
          Pete Simpson på sång och gitar<br />
          Johan Fernandes på bas<br />
          Micke Johansson på trummor
        </p>
        <p>
          Konserterna med Pete Simpson är en del av ett projekt som finansieras av EU genom Leader Sörmlandskusten.
        </p>
      </>
    );
  },
  datum: "2025-07-30",
    img: "pete_simpson",
      pris: 0,
        tid: "KL. 13 och 15",
          konsertmeny: false,
            music: true,
              foto: "",
                slutsålt: false,
  },

{
  id: 9,
    namn: function () {
      return <>Knock-Out Greg and the Blue Flames</>;
    },
  info: function () {
    return (
      <>
        <p>
          Denna konsert ingår i våra BLUESDAGAR 30 juli - 2 augusti. Under bluesdagarna kommer vi även ha blues dagtid med fri entré för de som gästar caféet. Biljett kan köpas separat till denna konsert men man kan även köpa ett BLUESPASS som ger entré till alla fyra blueskonserter till rabatterat pris.
        </p>
        <p>
          Greger ”Knock-out Greg” Andersson startade sin musikkarriär med den numera smått legendariska orkester K-O Greg & Blue Weather som turnerade hårt i närmare 20 år och släppte 7 album. 50 fyllda och med ett lastbilslass rutin i ryggen samlar han nu ihop några av Skandinaviens bästa musiker i blues/soul-genren. Vi kommer att få höra mycket blues men även en del oldschool soul.
        </p><p>
          I bandet återfinns som alltid Gregers yngre bror Marcus på trummor. Bröderna har spelat ihop i över 30 år sen starten i Gnesta 1988 och avverkat tusentals gig tillsammans. Basen hanteras av Lars Näsman känd bla som basist i Trickbag sen många år och en mängd andra sammanhang. På keyboard och sax återfinns Torbjörn Eliasson även han mångårig medlem av K-O Greg & Blue Weather. Tobbe spelade piano i Sven Zetterbergs band länge och blåser numera också sax i kultbandet The Beat from Palookaville.
        </p>
      </>
    );
  },
  datum: "2025-07-31",
    img: "knock-out-greg",
      foto: "",
        pris: 180,
          tid: "18:00",
            konsertmeny: true,
              music: true,
                youtube: "https://www.youtube.com/watch?v=eAn73gl7r5Q",
                  youtubenamn: "Further Information",
                    biljett_id: 1258159,
                      bluespass: 1264409,
  },

{
  id: 10,
    namn: function () {
      return <>Ladies got the Blues</>;
    },
  info: function () {
    return (
      <>
        <p>
          Denna konsert ingår i våra BLUESDAGAR 30 juli - 2 augusti. Under bluesdagarna kommer vi även ha blues dagtid med fri entré för de som gästar caféet. Biljett kan köpas separat till denna konsert men man kan även köpa ett BLUESPASS som ger entré till alla fyra blueskonserter till rabatterat pris.
        </p>
        <p>
          Ladies Got the Blues är ett musikerkollektiv och flermannaband bestående av Sveriges samlade unga (kvinnliga) blueselit som turnerat i Sverige och Europa sedan 2014. Bandet uppträder i olika konstellationer och är en hyllning till de kvinnliga musiker som starkt bidragit till genrens utveckling genom historien.
        </p>
        <p>
          Under 2023 har Ladies Got the Blues fokus på omtolkningar av kvinnors musik både genom historien och samtida artister inom blues och närliggande genrer. Både riktiga bluesklassiker och några mer otippade låtar står på menyn! Till krogbacken kommer en konstellation av sju musiker.
        </p>
        <p>
          Sen 2014 har bandet turnerat runt om i Sverige och Europa med sin show. Följ med på en resa från 1920-talets Mississippi till 2000-talets svenska scener där du bland annat hör musik av:
        </p>
        <p>
          – Sister Rosetta Tharpe (1915–1973) Gitarrist, kompositör och sångerska som har inspirerat artister som Aretha Franklin, Chuck Berry, Elvis Presley och TinaTurner.
        </p>
        <p>
          – Memphis Minnie (1897–1973) Kompositör, gitarrist och sångerska blev invald i Blues Foundations Hall of Fame 1980. Hon spelade in ungefär 200 sånger, låtar som sedan har tolkats och spelats in av bland andra Jefferson Airplane och Led Zeppelin.
        </p>
        <p>
          – Big Mama Thornton (1926–1984) Sångerska och kompositör som var den första att spela in låten Hound Dog som blev en stor hit på Billboards lista 1953.
        </p>
      </>
    );
  },
  datum: "2025-08-01",
    img: "ladies",
      pris: 230,
        tid: "18:00",
          konsertmeny: true,
            music: true,
              foto: "",
                slutsålt: false,
                  youtube: "https://www.youtube.com/watch?v=krpQq2txu3c",
                    youtubenamn: "I'm outta here",
                      youtube2: "https://www.youtube.com/watch?v=FO3KrhGf2do",
                        youtubenamn2: "Gun In My Hand",
                          biljett_id: 1258160,
                            bluespass: 1264409,
  },

{
  id: 11,
    namn: function () {
      return <>Eric Bibb</>;
    },
  info: function () {
    return (
      <>
        <p>
          Denna konsert ingår i våra BLUESDAGAR 30 juli - 2 augusti. Under bluesdagarna kommer vi även ha blues dagtid med fri entré för de som gästar caféet. Biljett kan köpas separat till denna konsert men man kan även köpa ett BLUESPASS som ger entré till alla fyra blueskonserter till rabatterat pris.
        </p>
        <p>
          Eric Bibb, född och uppvuxen i New York, är med sina över fyrtio album och mer än femtio år på scenen, en av den internationella bluesvärldens största namn idag och hyllningarna som en av världens främsta akustiska bluesgitarrister är ständigt återkommande.
        </p><p>
          Han har turnerat världen runt i snart trettio år, blivit Grammy-nominerad i USA tre gånger och fått mängder av andra internationella utmärkelser, som t. ex pris för årets akustiska bluesalbum från The Blues Foundation i Memphis 2017 & 2022 och ”Blues Act Of The Year” vid Jazz FM Awards i London 2019. 2022 fick Eric även Stockholms Stads hederspris i musik.
        </p><p>
          Erics far, artisten Leon Bibb, kämpade jämsides med Martin Luther King, Harry Belafonte, Joan Baez och många fler för svartas rättigheter i USA på sextiotalet. Leons framtidsvisioner och mål-medvetenhet tog sig uttryck i musiken och formade Erics konstnärsskap från tidig ålder. Hemma hos familjen Bibb rörde sig en konstant ström av erkända musiker och artister som John Lewis (Erics morbror - pianist/kompositör, grundare av Modern Jazz Quartet), Paul Robeson, Pete Seeger och Josh White. Eric minns särskilt tydligt hur han vid elva års ålder står i pyjamas i vardagsrummet och berättar för Bob Dylan att han minsann också spelar gitarr…
        </p><p>
          Eric har samarbetat med storheter som t.ex Mavis & Pops Staples, Taj Mahal, Odetta, Bonnie Raitt, The Blind Boys of Alabama och The Dixie Hummingbirds. 2019 spelade han för utsålda hus i en vecka på legendariska Ronnie Scott’s i London, då även Van Morrison var Eric’s gäst en av kvällarna.
        </p><p>
          2017 turnerade han Sverige runt med den hyllade enmans-föreställningen ”Tales From A Blues Brother”, som också sändes i Sveriges Television. Den producerades av hans son Rennie Mirro och Filip Adamo och kan nu ses på Qwest TV. Ni har också kunnat se honom i På Spåret, SVT och Bingolotto, TV4, där han sjöng en duett med Sarah Dawn Finer. Sommaren 2022 såg ni honom i SVT:s Allsång På Skansen!
        </p><p>
          2021 släppte han plattan ”Dear America” med gäster som bl. a Ron Carter, Eric Gales och Steve Jordan. 2023 släpptes hans opus Ridin’, den liksom Dear America producerades av Glen Scott, nu med gäster som Taj Mahal och Russell Malone.
        </p><p>
          I september 2022 kunde du se honom på Scalateaterns scen Stockholm tillsammans med ett spännande band och gästerna Sarah Dawn Finer och Rennie Mirro. Konserten spelades in och filmades inför ett live-album, som släpptes i april 2024. Hösten 2023 medverkade han i föreställningen ’Ögonblicket’ på Västmanlands Teater och är just nu aktuell i rollen som den demente musikern John i filmen ’Så Länge Hjärtat Slår’, som kan ses på TV4 Play.
        </p>
        <p>
          Till Oxelö Krog kommer Eric denna gång tillsammans med gitarristen Gunnar Muvemba Lidström, Greger "Knock-Out" Andersson på munspel samt Ulrika Bibb på sång.
        </p>
      </>
    );
  },
  datum: "2025-08-02",
    img: "Eric-Bibb",
      pris: 280,
        tid: "18:00",
          konsertmeny: true,
            music: true,
              foto: "Michael Wall",
                slutsålt: false,
                  youtube: "https://youtu.be/HYhwUgl3P0U?si=Rcf3quZItAXlTj_i",
                    youtubenamn: "Family",
                      youtube2: "https://youtu.be/j__moFFnAJg?si=ek6RKqQSL1YU0HyU",
                        youtubenamn2: "500 miles",
                          biljett_id: 1258157,
                            bluespass: 1264409,
  },

{
  id: 12,
    namn: function () {
      return <>Herman Lindqvist</>;
    },
  info: function () {
    return (
      <>
        <p>
          Vi är oerhört glada att det har blivit en tradition att Herman Lindqvist kommer till oss! Vi hälsar honom hjärtligt välkommen tillbaka till Krogbacken!<br /><br />
          Denna gång kommer Herman berätta om sin nya bok "När Sverige var i gungning - Frihetstiden i skuggan av det ryska hotet" om ett land i inrikespolitiskt kaos som var mycket nära att bli en rysk vasallstat.
        </p>
        <p>Ingen kan som Herman berätta vittert och underhållande direkt ur minnet! Missa inte det!</p>
        <p>
          Herman Lindqvist har skrivit över sextio böcker och han skriver ständigt fler. Det är framför allt historiska verk, men också skönlitteratur, biografier, kåserier m.m.
        </p><p>
          Han föddes i Stockholm 1943, men växte upp i Helsingfors. Han tog studenten, läste statskunskap och började sitt yrkesliv som journalist. Vid 25 års ålder blev han utrikeskorrespondent för Aftonbladet och bevakade sedan under mer än tjugo år krig och katastrofer i alla världsdelar för Aftonbladet, Expressen, SVT och Riksradion. Numera är han bosatt i Warszawa.
        </p><p>
          År 1969 debuterade han med en reportagebok om den ryska invasionen av Tjeckoslovakien. I sin skönlitterära debut Strax före deadline (1980) skildrade han sina upplevelser då de röda khmererna tog över Pnom Penh i Kambodja.
        </p><p>
          Sedan 1990 är han heltidsförfattare. Under åren 1992–2006 utgavs hans stora verk Historien om Sverige i elva delar. Den bokserien har tillsammans med de omkring trettio avsnitten av Hermans historia som sändes i SVT mellan 1991 och 2002 starkt bidragit till det ökade historieintresset i Sverige. Många har vittnat om att det är Herman Lindqvists medryckande sätt att berätta som har fått dem intresserade av historia.
        </p><p>
          Herman Lindqvist har en djup kunskap om Sveriges kungahus, som han har skrivit flera böcker om, senast Kungligt och mänskligt (2010). Han har också undervisat prinsessorna Victoria och Madeleine i Sveriges historia.
        </p><p>
          Hans serie om franska historiska personligheter började 2008 med Madame de Pompadour, ett porträtt av 1700-talsborgarflickan som blev kunglig älskarinna och fick en maktställning som få andra. Året därpå kom Jean Bernadotte, mannen vi valde, om den franske marskalken som blev vår förste kung av ätten Bernadotte, Karl XIV Johan, och våren 2011 kom Ludvig XIV, Solkungen.
        </p><p>
          Herman Lindqvists självbiografi om livet som journalist och författare, Mitt i allt, kom 2012. Året därpå skrev han en bok han länge velat skriva, om Sveriges och Finlands gemensamma historia: När Finland var Sverige. För den belönades han med 18 000 euro av Svenska Litteratursällskapet i Finland och med ett hedersdoktorat vid Åbo Akademi. Därefter har den flitige författaren också skrivit om Erik XIV och om Sverige som kolonialmakt, något som ingen tagit ett samlat grepp om tidigare.
        </p>
        <p>
          Varmt välkomna!
        </p>
      </>
    );
  },
  datum: "2025-06-24",
    img: "Herman-Lindqvist",
      pris: 0,
        tid: "14:00",
          konsertmeny: false,
            music: false,
              author: true,
  },

{
  id: 13,
    namn: function () {
      return <>Henrik Berggren</>;
    },
  info: function () {
    return (
      <>
        <p>
          Det är en stor ära för oss att välkomna Henrik Berggren till Oxelö Krog! Henrik Berggren har varit kulturchef och ledarskribent på Dagens Nyheter. Som författare har han publicerat en lång rad kritikerrosade böcker, bland andra Är svensken människa? Gemenskap och oberoende i det moderna Sverige (med Lars Trägårdh), Underbara dagar framför oss: en biografi över Olof Palme  och Dag Hammarskjöld: Att bära världen. Han har också skrivit om det spanska inbördeskriget, om New York, om året 1968 och om universitetets historia. Förra året utsågs han till årets pristagare av Stora historiepriset, som är Sveriges största historiepris. ”Hos Henrik Berggren förenas på bästa sätt historikerns källkritiska blick med journalistens kvicka penna och folkbildarens berättarlust” skriver juryn i sin motivering.
        </p>
        <p>
          Prisvärd är även den nyss avslutade trilogin, Landet utanför. Sverige och kriget 1939–1940, respektive 1940–1942 och 1943–1945, publicerade 2018, 2021 och 2023. Trebandverket har samfällt och med rätta kallats ett storverk, en klassiker och ett mästerverk. Med kunskap och schwung lyckas Berggren skapa en bladvändare på 1400 sidor om Sverige under andra världskriget, där freden ska säkras genom en balanserande anpassningspolitik. Särskilt lyckat är hans grepp att låta storpolitik och vardagsliv löpa parallellt. Så får Per Albin Hansson och Torgny Segerstedt dela sidor med Astrid Lindgren, Karl Gerhard, hembiträden och landsfiskaler. Fram träder ett Sverige som samtidigt betraktas med historikerns efterkloka analys och samtidens levande, strävande, drömmande, kluvna, älskande och ömsom modiga, ömsom bristfälliga människor. Det är oemotståndligt och djupt bildande.
        </p>
        <p>
          Stora historiepriset delas ut av Sörmlands museum och Nyköpings kultur- och fritidsnämnd till historiker eller annan, som – utan att göra avkall på fackmässig korrekthet – lyckats föra ut historiska kunskaper och forskningsresultat i en vidare krets så att intresset för ämnet ökat. Det har delats ut årligen sedan 1994 och gått till några av Sveriges mest erkända historiker. Prissumman är 100 000 kronor.
        </p>
        <p>
          Här följer några av de andra priser och utmärkelser som Henrik Berggren fått.<br />
          John Landquists pris av Samfundet de Nio 2011<br />
          Natur & Kulturs Johan Hansson-pris 2011<br />
          Axel Hirschs pris av Svenska Akademien, 2011<br />
          Stipendium ur Stipendiefonden Albert Bonniers 100-årsminne, 2010<br />
          Nöjesguidens Stockholmspris 2010<br />
          Stiftelsen Klockrosens stipendium 2024<br />
          Stora Fackbokspriset 2023
        </p>
        <p>
          Missa inte detta!
        </p>
      </>
    );
  },
  datum: "2025-07-01",
    img: "henrik_berggren",
      pris: 0,
        tid: "14:00",
          konsertmeny: false,
            music: false,
              author: true,
  },

{
  id: 14,
    namn: function () {
      return <>Fredrik Lundberg</>;
    },
  info: function () {
    return (
      <>
        <p>
          Vi hälsar med glädje författaren och journalisten Fredrik Lundberg välkommen till Krogbacken!
        </p>
        <p>
          Med en bakgrund som ansvarig utgivare för TV4:s Kalla fakta och programdirektör på MTG TV, har Lundberg en lång karriär inom mediebranschen, där han har arbetat med både grävande journalistik och tv-produktioner.
        </p>
        <p>
          Fredrik Lundberg är uppvuxen i Nyköping. Han debuterade skönlitterärt 2024 med thrillern Tigerns år, en spänningsroman som utspelar sig i 1990-talets tv-värld och följer den grävande reportern Lars Ferm. Boken har hyllats för sitt fängslande berättande och skarpa karaktärsskildringar. Hans kommande bok, Kaninens år, är den andra delen i serien om Lars Ferm, där han fortsätter att navigera genom en värld fylld av intriger och mörka hemligheter.
        </p>
        <p>
          I sitt föredrag på Oxelö Krog kommer han att tala om sina erfarenheter som journalist, hur verkligheten ofta överträffar fiktionen och hur man kan få in nyköpingsslang i en bok som till stora delar utspelar sig i Afrika.
        </p>
      </>
    );
  },
  datum: "2025-07-08",
    img: "Fredrik-Lundberg",
      pris: 0,
        tid: "14:00",
          konsertmeny: false,
            music: false,
              author: true,
  },

{
  id: 15,
    namn: function () {
      return <>Lasse Hoffman</>;
    },
  info: function () {
    return (
      <>
        <p>
          Lasse Hoffman har skrivit en bok om sin svärmors kusin som från hans hemstad Tallinn blev deporterad två gånger av NKVD.
          Så här berättar han själv:
        </p>
        <p>
          Min bok »Jag kommer tillbaka« börjar när andra världskriget börjar, och Estland var offret för den tidens ryska imperialismen. I centrum står den nioårige Jüri, förövrigt min svärmors kusin, och vi får följa honom genom livets olika skiftningar.
        </p>
        <p>
          Det ryska ledarskiktets imperialistiska strävanden har genom århundradena tagit sig olika uttryck. Att kuva svagare grannländer har blivit ett signum för ryska ledare. Efter Sovjetunionens fall trodde många att detta inte skulle fortsätta, men esterna såg snart orosmolnen hopa sig. De försökte varna oss i väst, men vi ville inte lyssna. Idag är därför Ukraina och det ukrainska folket offren.
        </p>
      </>
    );
  },
  datum: "2025-07-15",
    img: "lasse-hoffman",
      pris: 0,
        tid: "14:00",
          konsertmeny: false,
            music: false,
              author: true,
  },
{
  id: 16,
    namn: function () {
      return <>Emily Doyle</>;
    },
  info: function () {
    return (
      <>
        <p>
          Emily Doyle ser sig själv som hästflickan som blev författare. Hon debuterade 2023 med romanen ”Och även du, min älskade” som är en historisk kärleksroman i hästmiljö. Nu kommer den efterlängtade uppföljaren ”Även ett hjärta sin skugga har”. Emilys stora intresse för historia och hästar löper som en gyllene tråd genom hennes böcker. Författarinnan har rötter i Irland vilket också avspeglas i hennes författarskap. "Målet med mina böcker är att underhålla och beröra läsaren. De ska svepas med i historien, skratta och gråta tillsammans med mina karaktärer och alltid vilja läsa vidare." Hör henne berätta på krogbacken!
        </p>
        <p>
          Del I, Och även du, min älskade<br />
          Romanen handlar om en ung kvinna som får ett svårt uppdrag i en miljö som på den tiden dominerades av män. Hon är duktig och det ger henne fiender. En förälskelse med ”fel man” ger henne ytterligare fiender och nu är det inte bara farliga utan också mäktiga.
          Fidelma har fått bra värderingar, hon drivs av nyfikenhet och längtan efter kunskap. Hon litar på människorna i sin omgivning även om de kommer med lögner. Hon förstår inte att folk har dolda agendor, och därför blir hon lätt att utnyttja. Hon inser inte heller hur skicklig och ovärderlig hon faktiskt är och därför kan hon inte använda det till sin egna fördel.
          Romanen genomsyras av dåtidens polarisering, de sociala orättvisorna, dels mellan olika samhällsklasser men också mellan män och kvinnor. Även djurens utsatthet blir påtaglig. Hur utsatta de är från vårt goda omdöme och välvilliga behandling.
        </p>
        <p>
          Del II, Även ett hjärta sin skugga har<br />
          I del II har vi förflyttat oss till London, strax efter andra världskrigets utbrott med alla de utmaningar ett krig kan ställa karaktärerna inför. Fidelma känner starkt att hon vill bidra med något för att vinna detta förhatliga krig och det är på den vägen hon träffar Martin Isaksson. Martin är en svensk läkare som gränslat sin motorcykel och lämnat Sverige för att fly sitt skuldtyngda förflutna.Deras förälskelse är på intet sätt självklar, det finns en rad problem som måste övervinnas. När allt äntligen verkar ljusna gör ett oväntat möte att händelserna från sommaren 1939 på Irland (del ett) kommer i ett nytt perspektiv och Fidelma ställs inför ett ödesdigert val.
        </p>
      </>
    );
  },
  datum: "2025-07-22",
    img: "emily-doyle",
      pris: 0,
        tid: "14:00",
          konsertmeny: false,
            music: false,
              author: true,
  },
{
  id: 17,
    namn: function () {
      return <>Lasse Lindberg</>;
    },
  info: function () {
    return (
      <>
        <p>
          Vi hälsar kultur- och Oxelösundsprofilen och entertainern Lasse Lindberg välkommen till krogbacken.
        </p>
        <p>
          <ExtraImage src={Strato} />
          Lasse är född och uppvuxen i Oxelösund. Pappa hade godis och fruktaffär.

          Lasse började medverka i Nyköpings Gästabud 1974 fortsatte medverka i olika roller i hela 25 år!!
        </p>
        <p>
          Lasse är visserligen ännu inte författare av några böcker, men han skriver visor och texter och han har också författat en mängd kåserier.
        </p>
        <p>
          På krogbacken kommer han att berätta om sitt Oxelösund; minnen och anekdoter ur historien.
        </p>
      </>
    );
  },
  datum: "2025-07-29",
    img: "lasse-lindberg",
      pris: 0,
        tid: "14:00",
          konsertmeny: false,
            music: false,
              author: true,
                inställt: true,
  },
{
  id: 18,
    namn: function () {
      return <>Tomas Lappalainen</>;
    },
  info: function () {
    return (
      <>
        <p>
          Det är en stor ära att få hälsa författaren Tomas Lappalainen välkommen till krogbacken!
        </p>
        <p>
          Tomas Lappalainen arbetar som kulturredaktör på LO-tidningen samt medverkar regelbundet i Aftonbladet. Han är även en av vårt lands främsta Italienkännare. Han har skrivit facklitteratur om Italien särskilt den italienska maffian vars tre huvudgrenar han har behandlat i böckerna Maffia, Camorra och 'Ndrangheta. I boken Se Neapel och sedan dö försöker Tomas Lappalainen förstå vad det är som gör Neapel så annorlunda. Han har även skrivit den delvis självbiografiska Mellan 55 och 60 och om antikens Grekland i Världens första medborgare.
        </p>
        <p>
          Några recensioner av Se Neapel och sedan dö:<br /><br />
          ”Låt mig genast säga att detta är en underbar bok.”
          Harald Hamrin, Svenska Dagbladet
          <br /><br />
          ”Att Se Neapel och sedan dö blir August-nominerad ser jag som en självklarhet, för här förenas essäns stringens med reportagets sensuella konkretion och romanens suggestion i en tankeklar språkdräkt som gnistrar och skimrar av en samtidigt livlig och sträv humor, en sant napolitanskt skamlös odygdig dygd.”
          Ragnar Strömberg, Göteborgs-Posten
          <br /><br />
          ”Jag har sällan – möjligen aldrig – läst en så passionerad och uttömmande beskrivning av en stad och en mentalitet. ( ) Se Neapel och sedan dö är en bok i vilken man blir rånad på sin sinnesfrid.”
          Carina Waern, Helsingborgs Dagblad
        </p>
        <p>
        </p>
      </>
    );
  },
  datum: "2025-08-05",
    img: "tomas-lappalainen",
      pris: 0,
        tid: "14:00",
          konsertmeny: false,
            music: false,
              author: true,
  },
{
  id: 19,
    namn: function () {
      return <>Marie Sälmark</>;
    },
  info: function () {
    return (
      <>
        <p>
          Sommarens sista författare på krogbacken är författaren och journalisten Marie Sälmark. Vi hälsar henne varmt välkommen till Oxelö Krog! Så här skriver hon om sig själv:
        </p>
        <p>
          Jag bestämde mig tidigt i livet för att bli författare och blev antagen till författarutbildning på Uppsala Universitet 1976. Men efter en termin kom jag också in på Journalisthögskolan och la mina författarplaner på hyllan. Verkade ju lättare att försörja mig som journalist än författare, tänkte jag. Drygt 30 år senare blev jag ombedd att skriva om en levnadshistoria som jag inte kunde tacka nej till.
        </p>
        <p>
          Min första bok är alltså en reportagebok om Blanca Firpo, flykting från militärdiktaturens Argentina. (Kanske kommer du ihåg svenskan Dagmar Hagelin som  togs av militären och försvann?) Blanca som var aktiv i motståndet mot diktaturen fängslades, torterades, våldtogs och misshandlades i samma fängelse som Hagelin. Blanca och hennes familj kom till Nyköping som kvotflyktingar via UNHCR 1983.
        </p>
        <p>
          Efter boken om Blanca gick jag i pension och fortsatte att skriva.
          Min andra bok är novellsamlingen "Kan en ensam trana dansa?"
        </p>
        <p>
          Roger Kellerman, Publisher på Meetings International, recenserade så här:
          ”Novell efter novell är lika bra och några är ännu bättre. Det känns märkligt nog som en slags roman så sammanhållna är novellerna. Visst det är olika människor, olika förutsättningar i livet, men här finns ett språk som träffar djupt inne i min själ.
          Här finns stråk av en av min ungdoms stora författare, den magiske holländaren Jan Wolkers böcker ’Turkisk konfekt’, och ’En ros av kött’, utan att jag kan peka närmare på varför. Bara känslan av att här finns en författare som omedelbart måste påbörja sin första roman i en serie romaner om vart vårt land är på väg, med ursprung från varifrån vi kommer och hur det hela gick till. Tror vi är någonting väldigt fint på spåren.”
        </p>
        <p>
          Nu håller jag på med min första roman. Den utspelar sig på en ö i den sörmländska skärgården. Det stora kriget har brutit ut och några människor på flykt träffas och försöker överleva.
        </p>
        <p>
        </p>
      </>
    );
  },
  datum: "2025-08-12",
    img: "marie-salmark",
      pris: 0,
        tid: "14:00",
          konsertmeny: false,
            music: false,
              author: true,
  },
{
  id: 20,
    namn: function () {
      return <>BELLMANDAGEN</>;
    },
  info: function () {
    return (
      <>
        <p>
          Vår traditionella Bellmandag blir i år på en söndag. Som vanligt
          kommer krogbacken att befolkas av 1700-talsklädda individer och vi
          klär även upp vår personal!
        </p>
        <p>
          Thord Lindé kommer att underhålla såsom Fredman. Den här gången har han med sig två eminenta jazzmusiker; Erik Söderlind på gitarr och Jan Adefelt på kontrabas. Erik Söderlind är en av Sveriges främsta jazzgitarrister och har erhållit en mängd priser och spelar över hela världen. Jan Adefelt är en av Sveriges mest erfarna och respekterade jazzbasister och har även varit huvudlärare i kontrabas på Kungl. musikhögskolan. Det kommer att bjudas på Bellmantolkningar med en dragning åt jazz och blues.
        </p>
        <p>
          Vi bjuder även på ett gästframträdande av folk- och vistrion ro.t (Rebecka O'Nils Trio) bestående av Rebecka O’Nils, Jenny Klefbom och William Bülow O’Nils. Det blir fin stämsång till gitarr.
        </p>
        <p>
          Bellman-quiz för stora och små utlovas med fina Bellman-priser!
        </p>
        <p>
          De som kommer 1700-talsklädda bjuder vi på något att äta. Så ta fram din gamla 1700-talsdräkt ur garderoben!
        </p>

        <p>
          Hålltider:<br />
          <ul>
            <li>kl. 12 Thord Lindé med Erik Söderlind och Jan Adefelt</li>
            <li>kl. 13 Folk- och vistrion ro.t.</li>
            <li>kl. 14 Thord Lindé med Erik Söderlind och Jan Adefelt</li>
            <li>kl. 14:40 Vinnarna i årets Quiz koras.</li>
          </ul>
        </p>

        <p>Varmt välkomna!</p>
      </>
    );
  },
  datum: "2025-07-27",
    img: "bellmandagen",
      pris: 0,
        tid: "HELA DAGEN",
          konsertmeny: false,
            music: true,
              youtube: "https://www.youtube.com/watch?v=t1ggVXHyvNw",
                youtubenamn: "SOLEN GLIMMAR",

  },

{
  id: 21,
    namn: function () {
      return <>Allsång på Krogbacken</>;
    },
  info: function () {
    return (
      <>
        <p>
          En skön allsångskväll på Krogbacken! Visgruppen Gott och Blandat bjuder dig att sjunga med i en mängd svenska visor av bl.a: Evert Taube, Nils Ferlin, Cornelis, Fred Åkerström och Ted Gärdestad men även en och annan schlager eller poplåt! Det är härligt att sjunga! Och vad kan vara mysigare än att göra det tillsammans på krogbacken med utsikt över skärgårdsviken! Ta med din bästa sångröst och sjung med!
        </p>
        <p>
          <ExtraImage src={Blandat} />
          Gott och Blandat bildades hösten 2015 och är delvis en fortsättning av Sånggruppen "Blandat" som var mycket populära från mitten 70 talet fram till 2005. Gruppen medverkade i TV program som Cafe Norrköping med Ragnar Dahlberg och Dax med Åke Wilhelmsson.
        </p>
        <p>
          Blandat gjorde två LP-skivor som spelades flitigt i både riks och lokalradion och var även på test till Svensktoppen. Gruppen uppträdde bl.a på Skansen Solidens stora scen inför sextusen entusiastiska åhörare med konferencier Bosse Larsson och ett artistuppbåd och placerade sig på en hedrande andraplats i en riksomfattande Taubetävling som anordnades av landets lokalradiostationer.
        </p>
        <p>
          Medlemmar:<br />
          Tomas Björklund: Gitarr & sång.<br />
          Kenneth Karlsson: Bas & percussion<br />
          Lasse Fornarve: Klaviatur, dragspel & sång<br />
        </p>
      </>
    );
  },
  datum: "2025-08-09",
    img: "allsång",
      pris: 100,
        tid: "18:00",
          standardmeny: true,
            music: true,
              foto: "",
                slutsålt: false,
                  biljett_id: 1279203,
  },
  */
  {
    id: 22,
    namn: function () {
      return <>FREDMAN - BRÄNNVINSAPOSTELN</>;
    },
    info: function () {
      return (
        <>

          <p>
            Uthärda höstens mörker och kyla bättre genom att låta er värmas, tröstas och upplysas av den ständigt okuvlige och tappre aposteln Fredman! Profetens famn är stor och generös, och han tar emot alla som vill låta sig omslutas av hans predikan, inspireras av hans röst, röras av hans tårar och skratta åt hans skämt!
          </p>
          <p>
            Låt er nedsänkas i det renande brännvinsbad som endast en Bacchi predikan kan erbjuda! Salighet, uppsluppenhet, glädje, gråt, vanmakt, vemod, värme, sorg, självömkan, grovhet, finstämdhet, smäktande sång och eminent gitarrspel utlovas!
          </p>
          <p>
            Som Fredman ser vi Bellmantolkaren Thord Lindé.
          </p>
          <p>
            Konserten ånjuts i krogstugan. I pausen serverar vi vår godaste räksoppa med handskalade lyxräkor och halloumismörgås på övervåningen.
          </p>
          <p>
            Kostnad är 350 kr inklusive mat.
          </p>

          <p>
            Så här gör du för att boka och betala konserten.<br />
            Swisha betalningen för samtliga biljetter som bokningen avser.
            Skriv i swishmeddelandet "Fredman" samt din e-postadress.<br />
            Swishnummer: 123 088 11 36 (Thord Lindé Tonkonst).
          </p>

          <p>
            När vi fått din betalning bekräftar vi din bokning med ett mail och då är du garanterad de platser som du beställt.
            Bekräftelse kan ta nån dag men vi svarar alltid.
          </p>
          <p>
            Observera att betalningen måste finnas på vårt konto senast dagen före konsertdatum.
          </p>
        </>
      );
    },
    datum: "2025-10-04",
    img: "fredman",
    pris: 1,
    tid: "18:00",
    kväll: false,
    music: false,
    tonkonst: true,
    slutsålt: false,
    youtube: "https://www.youtube.com/watch?v=t1ggVXHyvNw",
    youtubenamn: "Solen Glimmar",
  },

  {
    id: 23,
    namn: function () {
      return <>HELKVÄLL I KROGSTUGAN</>;
    },
    info: function () {
      return (
        <>

          <p>
            <ExtraImage src={Brasa} />
            Äntligen har krogen kvällsöppet! Ta med dina kompisar och njut av en helkväll framför brasan i vår anrika krogstuga! En kväll att bara umgås och njuta i vår fina 1700-talsmiljö med ett glas öl och något att äta och kanske även en kväll att föreställa sig hur det kan ha gått till på 1700-talet när sjömännen festade här, diskuterade och ljög, grälade och slogs. Det behöver inte gå lika vilt till som på bilden ovan av Tobias Sergel. Kanhända tar krögaren fram sin gitarr och sjunger något. Kanhända blir det även lite allsång. Några gamla sjömansvisor kanske?
          </p>
          <p>
            Vi serverar krögarens bästa portergryta på högrev, med vinbärsgele, potatis och sallad. Pris 195 kr.
          </p>
          <p>
            Entré är gratis men föranmälan krävs. Maten behövs också förbeställas så vi vet hur mycket vi ska laga. Öl, vin och annat drickbart har vi givetvis i överflöd. Anmäl dig genom att skicka ett mail till hej@oxelokrog.se.
          </p>
          <p>
            Varmt välkomna!
          </p>
        </>
      );
    },
    datum: "2025-10-18",
    img: "krogkvall",
    pris: 1,
    tid: "18:00",
    kväll: false,
    music: false,
    tonkonst: true,
    slutsålt: false,
  }


];

export default artistInfo;